export default [
  {
    path: '/lembrar',
    view: 'Lembrar',
    default: true,
    title: 'Lembrar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/recuperar',
    view: 'Alterar',
    default: true,
    title: 'Alterar Senha',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/ativar',
    view: 'Ativar',
    default: true,
    title: 'Ativar conta',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/healthcheck',
    view: 'HealthCheck',
    default: true,
    title: 'Health Check',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  },
  {
    path: '/',
    view: 'Login',
    default: true,
    title: 'Login',
    menu: false,
    meta: {
      anonymousAuth: true
    }
  }
]
